import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  get isServer(): boolean {
    return isPlatformServer(this.platformId);
  }

  get window(): any {
    if (this.isBrowser) {
      return window;
    }
    return undefined;
  }

  get document(): any {
    if (this.isBrowser) {
      return document;
    }
    return undefined;
  }

  get localStorage(): any {
    if (this.isBrowser) {
      return localStorage;
    }
    return undefined;
  }

  get sessionStorage(): any {
    if (this.isBrowser) {
      return sessionStorage;
    }
    return undefined;
  }
}
